import { Award, Hotel } from 'lucide-react';

const partners = [
  { name: 'ZAV – Bundesagentur für Arbeit', type: 'institution', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/qbqynw7p_Logo%20Bundesagentur%20f%C3%BCr%20Arbeit.jpg' },
  { name: 'DEHOGA', type: 'partner', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/sqhg2e83_Logo%20Dehoga.png', logoOnly: true },
  { name: 'Bauindustrie-Verband', type: 'partner', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/r84khpyx_Logo%20Bauindustrie%E2%80%91Verband.jpg', logoOnly: true },
  { name: 'VDAB', type: 'partner', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/d6djdwxo_Logo%20VDAB.png', logoOnly: true },
  { name: 'IHK FOSA', type: 'institution', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/s3cs84k4_Logo%20IHK%20FOSA.png', logoOnly: true },
  { name: 'Bundesverband Spedition & Logistik', type: 'partner', logo: 'https://customer-assets.emergentagent.com/job_b44b09f1-672d-48bd-9d48-f304c40717b4/artifacts/m5ixrxoc_Logo%20Bundesverband%20Spedition%20%26%20Logistik_files.png', logoOnly: true },
  { name: 'Hotellerie Deutschland', type: 'partner', logo: null },
];

const PartnerCard = ({ partner, dupKey }) => (
  <div
    key={dupKey}
    className="flex-shrink-0 flex items-center gap-3 px-6 py-3 bg-white rounded-xl border border-gray-100 shadow-sm"
  >
    <div className={`flex items-center justify-center shrink-0 ${partner.logoOnly ? 'w-28 h-14' : 'w-12 h-10'}`}>
      {partner.logo ? (
        <img
          src={partner.logo}
          alt={partner.name}
          className={`object-contain ${partner.logoOnly ? 'max-h-14 max-w-[112px]' : 'max-h-10 max-w-[80px]'}`}
        />
      ) : (
        <Hotel className="w-8 h-8 text-gray-400" />
      )}
    </div>
    {!partner.logoOnly && (
      <span className="text-gray-700 font-medium whitespace-nowrap">{partner.name}</span>
    )}
  </div>
);

const LogosSection = () => {
  return (
    <section className="py-8 md:py-12 bg-gray-50 border-y border-gray-100" data-testid="logos-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-6">
          <p className="text-sm text-gray-500 font-medium flex items-center justify-center gap-2">
            <Award className="w-4 h-4 text-primary" />
            Partenaires & Certifications reconnus
          </p>
        </div>

        {/* Scrolling logos */}
        <div className="relative overflow-hidden">
          {/* Fade gradients */}
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />

          {/* Scrolling container */}
          <div className="logos-track flex items-center gap-12 animate-scroll-slow hover:pause-animation">
            {partners.map((partner, index) => (
              <PartnerCard key={index} partner={partner} />
            ))}
            {partners.map((partner, index) => (
              <PartnerCard key={`dup-${index}`} partner={partner} dupKey={`dup-${index}`} />
            ))}
          </div>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-4 mt-6">
          <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-gray-200 text-sm">
            <span className="text-green-500">✓</span>
            <span className="text-gray-600">Certifications Goethe/TELC/ECL</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-gray-200 text-sm">
            <span className="text-blue-500">🏢</span>
            <span className="text-gray-600">7 partenaires allemands</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LogosSection;
